import React from 'react';
import theme from '../../theme';
import { IconProps } from './props'

const CloseIcon: React.FC<IconProps> = ({ id, iconColor = theme.textDark, ...rest }) => (
    <svg
        id={id}
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.047 5.29289C19.4375 5.68342 19.4375 6.31658 19.047 6.70711L7.04695 18.7071C6.65643 19.0976 6.02326 19.0976 5.63274 18.7071C5.24221 18.3166 5.24221 17.6834 5.63274 17.2929L17.6327 5.29289C18.0233 4.90237 18.6564 4.90237 19.047 5.29289Z"
            fill={iconColor}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.63274 5.29289C6.02326 4.90237 6.65643 4.90237 7.04695 5.29289L19.047 17.2929C19.4375 17.6834 19.4375 18.3166 19.047 18.7071C18.6564 19.0976 18.0233 19.0976 17.6327 18.7071L5.63274 6.70711C5.24221 6.31658 5.24221 5.68342 5.63274 5.29289Z"
            fill={iconColor}
        />
    </svg>
);

export { CloseIcon };